module.exports = __webpack_public_path__ + "static/media/in_a_week_8.7c62141d.jpg";